if(typeof null === 'undefined') { var e = new Error("Cannot find module 'null'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = null;